module.exports = __webpack_public_path__ + "static/media/franchise-01.6ecaa30c.png";